const ja = {
  translation: {
    // ─── Common ────────────────────────────────────────────────────────
    common: {
      loading: '読み込み中...',
      error: 'エラー',
      cancel: 'キャンセル',
      confirm: '確認',
      save: '保存',
      delete: '削除',
      done: '完了',
      back: '戻る',
      close: '閉じる',
      retry: '再試行',
      ok: 'OK',
      yes: 'はい',
      no: 'いいえ',
      or: 'または',
      and: 'および',
      years: '歳',
      noData: 'データなし',
      seeAll: 'すべて見る',
      logout: 'ログアウト',
      logoutConfirm: 'ログアウトしてもよろしいですか？',
      continue: '続ける',
      month: '月',
      months: 'ヶ月',
    },

    // ─── Tabs ──────────────────────────────────────────────────────────
    tabs: {
      home: 'ホーム',
      classes: 'クラス',
      training: 'トレーニング',
      profile: 'プロフィール',
    },

    // ─── Auth ──────────────────────────────────────────────────────────
    auth: {
      welcomeBack: 'おかえりなさい',
      signInSubtitle: 'アカウントにサインイン',
      appDescription: 'CBJJ Saigonの会員、クラス、トレーニングの進捗を管理します。',
      email: 'メールアドレス',
      password: 'パスワード',
      signIn: 'サインイン',
      noAccount: 'アカウントをお持ちでないですか？',
      register: '登録',
      createAccount: 'アカウント作成',
      joinCbjj: 'CBJJ サイゴンに参加する',
      firstName: '名',
      lastName: '姓',
      iAmA: '私は：',
      alreadyHaveAccount: 'すでにアカウントをお持ちですか？',
      signInLink: 'サインイン',
      // Roles
      roleAthlete: '選手',
      roleGuardian: '保護者',
      roleCoach: 'コーチ',
      // Validation
      emailRequired: 'メールアドレスを入力してください',
      passwordRequired: 'パスワードを入力してください',
      firstNameRequired: '名を入力してください',
      lastNameRequired: '姓を入力してください',
      loginFailed: 'ログインに失敗しました',
      registrationFailed: '登録に失敗しました',
      // Forgot / Reset password
      forgotPassword: 'パスワードをお忘れですか？',
      forgotPasswordSubtitle: 'メールアドレスを入力すると、リセットリンクをお送りします',
      sendResetLink: 'リセットリンクを送信',
      resetEmailSent: 'メールをご確認ください',
      resetEmailSentDetail: 'パスワードリセットリンクをメールアドレスに送信しました。',
      backToSignIn: 'サインインに戻る',
      resetPassword: 'パスワードをリセット',
      newPassword: '新しいパスワード',
      confirmPassword: 'パスワードを確認',
      passwordMinLength: 'パスワードは8文字以上である必要があります',
      passwordMismatch: 'パスワードが一致しません',
      passwordResetSuccess: 'パスワードのリセットが完了しました！',
      // Email verification
      verifyEmail: 'メールアドレスを認証',
      verifyEmailSubtitle: '{{email}}に認証コードを送信しました',
      verificationEmailSent: '認証メールを送信しました！',
      verificationCode: '認証コード',
      verifyCode: 'コードを認証',
      verificationCodeRequired: '認証コードを入力してください',
      invalidVerificationCode: '認証コードが無効です。もう一度お試しください。',
      tooManyRequests: '試行回数が多すぎます。しばらくしてからもう一度お試しください。',
      verificationSendFailed: '認証メールの送信に失敗しました',
      syncFailed: 'アカウントの同期に失敗しました。もう一度お試しください。',
      goToVerification: 'メールを認証',
      continueToApp: '続ける',
      resendVerification: '認証メールを再送信',
      resendIn: '{{seconds}}秒後に再送信',
      // Social login
      or: 'または',
      continueWithGoogle: 'Googleで続ける',
      continueWithApple: 'Appleで続ける',
      // Auth callback
      authenticating: '認証中...',
      authenticationFailed: '認証に失敗しました',
      callbackError: '認証中にエラーが発生しました。もう一度お試しください。',
      callbackNoVerifier: '認証データを受信できませんでした。もう一度サインインしてください。',
      // Profile completion (new users / OAuth)
      completeYourProfile: 'プロフィールを完成させる',
      completeProfileSubtitle: '開始するために、あと少しの情報が必要です。',
      dateOfBirth: '生年月日',
      birthdayRequired: '生年月日を入力してください',
      dateOfBirthRequired: '生年月日を入力してください',
      birthdayFormat: 'YYYY-MM-DD形式で入力してください',
      birthdayInvalid: '有効な日付を入力してください',
      selectDate: '日付を選択',
      profileUpdateFailed: 'プロフィールの更新に失敗しました',
      // Terms
      termsPrefix: '次に同意します：',
      privacyPolicy: 'プライバシーポリシー',
      termsAnd: 'および',
      termsOfService: '利用規約',
      termsRequired: 'プライバシーポリシーと利用規約に同意する必要があります',
      ageRequirement: '主ユーザーとして登録するには18歳以上である必要があります',
    },

    // ─── Home Screen ───────────────────────────────────────────────────
    home: {
      checkIn: 'チェックイン',
      scanAtDesk: 'フロントでスキャン',
      idPrefix: 'ID',
      nextClass: '今後のクラス',
      today: '本日',
      coachTba: 'コーチ未定',
      coachPrefix: 'コーチ {{name}}',
      mainMat: 'メインマット',
      noClassesToday: '本日の予定クラスはありません',
      pendingActivation: {
        title: '有効化待機中',
        body: 'お支払いはチームによる確認中です。\n\nお支払いの確認には最大1営業日かかる場合があります。\n\nQRチェックインは有効化後にご利用いただけます。',
      },
      membershipPaused: {
        title: '会員資格一時停止中',
        body: '会員資格は現在一時停止中です。\n\n一時停止期間中はチェックインできません。',
      },
      timeRestriction: 'プラン制限 {{start}} - {{end}}',
      noClassesInAllowedHours: 'プランの許可時間内にクラスはありません',
      dayRestrictionToday: '本日はプランで許可されていません',
      planNotValidToday: '本日のクラスはプランの対象外です',
    },

    // ─── Classes Screen ────────────────────────────────────────────────
    classes: {
      timetable: '時間割',
      loadingClasses: 'クラスを読み込み中...',
      noClassesScheduled: 'スケジュールされたクラスはありません',
      dayClosed: '本日休業',
      dayClosedOther: '休業',
      dayClosedPublicHoliday: '本日休業 - 祝日',
      closedPublicHoliday: '祝日休業',
      closedBadge: '休業',
      publicHolidayBadge: '祝日',
      timeChanged: '時間変更',
      timeRestriction: 'プラン許可時間 {{start}} - {{end}}',
      outsidePlanHours: 'プラン時間外',
      dayNotAllowed: 'この曜日はプランで許可されていません',
      // Day abbreviations (Japanese short weekday names)
      dayMon: '月',
      dayTue: '火',
      dayWed: '水',
      dayThu: '木',
      dayFri: '金',
      daySat: '土',
      daySun: '日',
    },

    // ─── Training Screen ───────────────────────────────────────────────
    training: {
      title: 'トレーニング記録',
      currentRank: '現在の帯',
      stripe_one: '{{count}}本のストライプ',
      stripe_other: '{{count}}本のストライプ',
      timeInBelt: '帯の在籍期間',
      months: '{{count}}ヶ月',
      days: '{{count}}日',
      lastPromo: '最終昇級日',
      coachNotes: 'コーチのメモ',
    },

    // ─── Profile Screen ────────────────────────────────────────────────
    profile: {
      guardian: '保護者：{{name}}',
      guardianTag: '保護者',
      age: '年齢：{{count}}歳',
      dob: '生年月日',
      membershipPayment: '会員プラン・支払い',
      currentPlan: '現在のプラン',
      noPlan: 'プランなし',
      active: '有効',
      inactive: '無効',
      nextPayment: '次回支払い',
      manageMembership: '会員プランを管理',
      hideHistory: '履歴を非表示',
      paymentHistory: '支払い履歴',
      payment: '支払い',
      noPaymentHistory: '支払い履歴はありません',
      familyMembers: 'ファミリーメンバー',
      pendingActivation: {
        title: '有効化待機中',
        body: 'お支払いはチームによる確認中です。\n\nお支払いの確認には最大1営業日かかる場合があります。',
      },
      belt: '{{name}}帯',
      viewing: '表示中',
      role: 'ロール',
      lightMode: 'ライトモード',
      darkMode: 'ダークモード',
      appSettings: 'アプリ設定',
      language: '言語',
      signOut: 'サインアウト',
      signingOut: 'サインアウト中...',
      noFamilyMembers: 'ファミリーメンバーはまだリンクされていません',
      addFamilyMember: 'ファミリーメンバーを追加',
      invite: {
        title: 'アプリに招待',
        editTitle: 'ログインメールを更新',
        edit: '招待を編集',
        invite: 'アプリに招待',
        registered: '登録済み',
        help: 'このQRコードまたはリンクを{{name}}と共有して、自分のアカウントを登録できるようにしましょう。',
        linkLabel: '招待リンク',
        copy: 'リンクをコピー',
        copied: 'リンクをコピーしました',
        expires: '{{date}}に期限切れ',
        regenerate: '新しいリンクを生成',
        failed: '招待の生成に失敗しました',
        welcome: '招待されています！',
        invitedBy: '{{guardian}}からの招待',
        athleteName: '名前',
        invalid: '無効な招待',
        notFound: 'この招待リンクは無効または期限切れです。',
      },
      managedBy: '{{name}}が管理',
      managedByFamily: 'ご家族が管理',
      managedByGuardian: 'このアカウントは{{guardian}}によって管理されています。',
      started: '開始日 {{date}}',
      ends: '終了日 {{date}}',
      membership: {
        title: 'メンバーシップ',
        plan: 'プラン',
        status: 'ステータス',
        expires: '有効期限',
        renew: 'メンバーシップを更新',
        noMembership: '有効なメンバーシップがありません',
        upgrade: 'プランをアップグレード',
        downgrade: 'プランをダウングレード',
      },
      logout: 'ログアウト',
      logoutConfirm: 'ログアウトしてもよろしいですか？',
      cancel: 'キャンセル',
      confirm: '確認',
      // App Settings Modal
      appName: 'アプリ名',
      version: 'バージョン',
      build: 'ビルド',
      platform: 'プラットフォーム',
      bundleId: 'バンドルID',
      channel: 'チャンネル',
      updateId: '更新ID',
      unknown: '不明',
      // Language options
      langEnglish: 'English',
      langVietnamese: 'Tiếng Việt',
      langJapanese: '日本語',
      pausedUntil: '{{date}}まで一時停止',
      pausedIndefinite: '無期限の一時停止',
      bodyMeasurements: '測定',
      bodyMeasurementsHint: '任意 — 会員の道着のサイズ決定に使用します',
      weight: '体重',
      height: '身長',
      metric: 'メートル法',
      imperial: 'ヤード・ポンド法',
    },

    // ─── App Header ────────────────────────────────────────────────────
    header: {
      athlete: '選手',
      switchRole: 'ロール切り替え',
      viewingAs: '表示中のロール',
      selfSuffix: '（自分）',
    },

    // ─── Billing Screen ────────────────────────────────────────────────
    billing: {
      membershipPricing: '会員プランと料金',
      checkout: 'お支払い',
      choosePlan: '1. プランを選択',
      checkoutStep: '2. お支払い',
      heroTitle: '会員プラン',
      heroPricing: '& 料金。',
      heroSubtitle: '世界レベルの柔術指導。あなたの目標に合ったプランをお選びください。',
      selectPlan: 'プランを選択',
      perMonth: '/ 月',
      currency: 'VND',
      targetedOfferBadge: '限定オファー',
      // Community Grant
      communityGrant: 'コミュニティ支援',
      communityGrantIndex: '06',
      communityGrantPrice: '最大45%オフ',
      communityGrantNote: '申請制',
      communityGrantDesc: '地元の現役選手・学生・ユースを支援。高レベルなトレーニングをより身近に。',
      applyNow: '今すぐ申請',
      communityGrantAlert: '申請フォームに移動中...',
      // Order Summary
      orderSummary: '注文内容',
      monthlySubscription: '月額サブスクリプション',
      subtotal: '小計',
      platformFees: 'プラットフォーム手数料',
      calculatedNext: '次回請求時に計算',
      totalDueToday: '本日のお支払い合計',
      total: '合計',
      // Payment Methods
      paymentMethod: 'お支払い方法',
      localBank: '国内銀行 / VietQR',
      localBankFees: '手数料0% · アプリで支払い',
      internationalCard: '海外カード',
      internationalCardSub: 'Visa、MasterCard、Amex',
      savedCards: '保存済みカード',
      recurringTokenized: '定期 · トークン化',
      tokenBadge: 'トークン',
      onepayPayment: 'OnePayカード決済',
      onepayDisabled: 'クレジットカード決済は近日公開',
      onepayCard: 'カードで支払う',
      payWithCard: 'Visa, MasterCard, JCB',
      useSavedCard: '保存済みカードを使用',
      // 9Pay Panel
      securedBy9Pay: '9Payによるセキュア決済',
      scanViaBanking: 'バンキングアプリでスキャン',
      scanViaBankingDesc: '国内バンキングアプリまたはeウォレットを開いてこのコードをスキャンしてください。金額はあらかじめ入力されています。',
      noAutoDeduct: '自動引き落としなし。',
      noAutoDeductDesc: '毎請求サイクルに新しい9PayリンクをZaloとメールでお送りします。',
      // Card Panel
      cardDetails: 'カード情報',
      savedCardTokenized: '保存済みカード · OnePay経由でトークン化',
      secureRedirect: 'セキュアリダイレクト',
      secureRedirectDesc: 'カード情報の入力のため、OnePay の決済ページに安全にリダイレクトされます。カード番号全体を当社が確認することはありません。',
      saveCardLabel: '次回請求サイクルのためにカードを保存する',
      saveCardDesc: 'お客様のカードはOnePay経由で安全に処理・トークン化されます。実際のカード番号は保存しません。',
      processing: '処理中...',
      payAmount: '{{amount}} を支払う',
      // Footer
      vatCompliant: 'VAT・電子インボイス対応',
      // Errors
      errorOpenPayment: '決済ページを開けません',
      paymentError: '決済エラー',
      saveAmount: '{{amount}}お得（{{count}}ヶ月毎）',
      discountPercent: '{{percent}}%オフ',
      discountFreeMonths: '{{count}}ヶ月無料',
      discountFreeMonths_other: '{{count}}ヶ月無料',
    },

    // ─── VietQR Screen ────────────────────────────────────────────────
    vietqr: {
      awaitingTitle: 'お支払いを完了してください',
      awaitingSubtitle: 'バンキングアプリでQRコードをスキャンして支払ってください。完了したら、「支払いを完了しました」をタップしてください。',
      confirmedTitle: '支払いを送信しました',
      confirmedSubtitle: '確認を受け取りました。\n\nお支払いの確認には最大1営業日かかる場合があります。\n\n確認完了後、メールで支払い領収書をお送りします。',
      confirmedContinueNote: '最終的な支払い確認をお待ちの間、アプリを引き続きご利用いただけます。',
      waitingTitle: 'お支払い待機中',
      waitingSubtitle: 'バンキングアプリでQRコードをスキャンして送金を完了してください。',
      successTitle: 'お支払い完了',
      successSubtitle: '会員プランが有効になりました。CBJJへようこそ！',
      failedTitle: 'お支払い失敗',
      failedSubtitle: 'お支払いが完了しませんでした。もう一度お試しください。',
      scanToPay: 'スキャンして支払う',
      accountName: '口座名義',
      accountNumber: '口座番号',
      bankBin: '銀行（BIN）',
      orderNumber: '注文番号',
      amount: '金額',
      orderDetails: '注文詳細',
      membershipOrder: '会員プラン注文',
      subtotal: '小計',
      discounts: '割引',
      total: '合計',
      status: 'ステータス',
      statusPending: '処理待ち',
      statusCompleted: '完了',
      statusFailed: '失敗',
      statusAwaitingVerification: '確認待ち',
      tryAgain: '再試行',
      noticeTitle: '支払い状況の監視',
      noticeAutoUpdate: '送金後、スタッフによる確認が必要です。確認が完了するとこの画面は自動的に更新されます。',
      noticeReconnecting: '支払い更新に再接続しています...',
      noticeDisconnected: 'リアルタイム更新が切断されました。今すぐ手動で確認できます。',
      noticeBody: 'アプリを閉じて再度開いても、このお支払いはシステムで確認されるまで有効です。',
      securedByVietQR: 'VietQRによるセキュア決済',
      pushPaymentTitle: 'VietQRプッシュ決済',
      pushPaymentSubtitle: 'ベトナムの銀行アプリでQRコードをスキャンしてください。金額と注文番号はあらかじめ入力されています。',
      noAutoDeduct: '自動引き落としなし',
      noAutoDeductDesc: 'これは手動のプッシュ決済です。毎請求サイクルに自分でバンキングアプリから送金を開始していただきます。',
      // Connection status
      connectionLost: '接続が切断されました',
      connectionLostBody: 'サーバーとのリアルタイム接続が切断されました。「今すぐ確認」をタップして支払い状況を確認してください。',
      checkNow: '今すぐ確認',
      checking: '確認中...',
      markPaidBtn: '支払いを完了しました',
      markingPaid: '確認中...',
      continueToApp: 'アプリを続ける',
      viewConfirmation: '確認ステータスを表示',
      backToPaymentInstructions: 'QRコードと振込詳細を表示',
      cancelPayment: '支払いをキャンセル',
      cancelConfirmTitle: '支払いをキャンセルしますか？',
      cancelConfirmDesc: 'この支払いをキャンセルしてもよろしいですか？請求書とQRコードは無効化され、チェックアウトプロセスをやり直す必要があります。',
      cancelConfirmBtn: 'はい、支払いをキャンセル',
      keepPaymentBtn: 'いいえ、支払いを維持',
      saveQrCode: 'QRコードを保存',
      mediaPermissionRequired: 'QRコードを保存するには写真へのアクセス権限が必要です。',
      qrSavedSuccess: 'QRコードをフォトライブラリに保存しました！',
      qrSavedFailed: 'QRコードを保存できませんでした。代わりにスクリーンショットを撮ってください。',
    },

    // ─── Pending Verification Banner ───────────────────────────────────
    pendingBanner: {
      title: '支払い確認待機中',
      listening: '監視中...',
      checkNow: '今すぐ確認',
    },

    // ─── Activation Success Banner ──────────────────────────────────────
    activationSuccess: {
      title: 'アカウントの有効化が完了しました！',
    },

    // ─── Subscription Screen (forced onboarding) ──────────────────────
    subscription: {
      choosePlan: 'プランを選択',
      heroTitle: '会員プランを選択',
      heroSubtitle: 'CBJJトレーニングを開始するためのプランを選択してください。',
      choosePlanSubtitle: 'トレーニング目標に合ったプランを選択してください。チェックアウト時に家族メンバーを追加できます。',
      duration: '請求サイクル',
      plans: 'プラン',
      vietqrPush: 'VietQRプッシュ決済',
      vietqrPushSub: '手数料0% · バンキングアプリで支払い',
      addMembers: 'メンバーを追加',
      addMembersTitle: '家族のプランを選択',
      addMembersSubtitle: '会員プランが必要な家族メンバーを追加してください。1回のお支払いで全員分をカバーします。',
      addFamilyMember: '家族メンバーを追加',
      addMember: 'メンバーを追加',
      addFamilyMembers: '家族メンバーを追加',
      add: '追加',
      addFamilyHint: '+追加をタップして家族メンバー（子供や扶養家族）を追加し、プランを選択してください。',
      familyMembers: '家族メンバー',
      familyMembersSubtitle: '各家族メンバーの会員プランを選択してください。',
      selectPlansForMembers: '各メンバーのプランを選択',
      selectMembershipToProceed: 'ご本人または家族メンバーのプランを選択して進んでください',
      selectPlan: 'プランを選択 →',
      skipPlanTitle: '後で',
      skipPlanDesc: '今すぐファミリーメンバーを追加したい場合に最適です。自分の登録はいつでもプロフィールから行えます。',
      continueToAddFamily: '家族追加へ進む',
      addFamily: '家族を追加',
      addAnotherMember: 'さらに追加',
      familyPromptTitle: '家族メンバーを追加しますか？',
      familyPromptSubtitle: '会員プランが必要なお子様や扶養家族はいますか？1回の支払いで全員分をカバーします。',
      familyPromptYes: 'はい、家族を追加',
      familyPromptNo: 'いいえ、自分だけ',
      selectPlanForMember: '{{name}}の会員プランを選択してください',
    },

    // ─── Referral System ─────────────────────────────────────────────
    referral: {
      title: '友達紹介',
      subtitle: '友達を紹介して、両方に1ヶ月無料',
      howItWorks: 'あなたの紹介コードを友達と共有してください。友達が参加して6ヶ月間アクティブでいると、両方のメンバーシップに+1ヶ月無料が追加されます。',
      yourCode: 'あなたの紹介コード',
      copy: 'コピー',
      copied: 'コピーしました！',
      share: '共有',
      shareMessage: 'CBJJサイゴンに一緒に参加しましょう！私の紹介コード{{code}}を使えば、6ヶ月後に両方に1ヶ月無料がもらえます。https://cbjj.app',
      status: {
        unused: 'あなたのコードは準備完了 — 友達に送りましょう！',
        pending: '{{name}}が{{date}}に参加しました。メンバーシップが有効であれば{{rewardDate}}に+1ヶ月無料が追加されます。',
        rewardAwarded: '{{date}}に+1ヶ月無料が追加されました。共有ありがとうございます！',
        rewardForfeited: '報酬を適用できませんでした — メンバーシップが有効ではなくなりました。',
        refereePending: '{{date}}に{{name}}のコードを使用しました。メンバーシップが有効であれば{{rewardDate}}に+1ヶ月無料が追加されます。',
        refereeAwarded: '{{date}}に{{name}}から+1ヶ月無料を受け取りました。',
        refereeForfeited: '紹介報酬を適用できませんでした — メンバーシップが有効ではなくなりました。',
      },
      checkoutPrompt: '紹介コードをお持ちですか？',
      apply: '適用',
      applied: '紹介コード適用済み',
      remove: '削除',
      rewardChip: '6ヶ月目に+1ヶ月無料',
      appliedSuccess: '✓ 紹介コードを適用しました。6ヶ月のアクティブメンバーシップ後に、あなたと{{name}}の両方に+1ヶ月無料が追加されます。',
      invalidCode: '無効な紹介コード',
      unappliedCodeTitle: '紹介コードを適用しますか？',
      unappliedCodeMessage: '紹介コードを入力しましたが、まだ適用していません。「適用」を押して使用するか、フィールドをクリアして続行してください。',
      membershipNote: {
        pending: '紹介ボーナス保留中 — {{date}}に+1ヶ月無料が適用されます',
        awarded: '紹介ボーナス適用済み — {{date}}に+1ヶ月無料が追加されました',
        forfeited: '紹介ボーナスを適用できませんでした',
      },
      youUsedCode: '紹介コードを使用しました',
    },

    // ─── Payment Result Screen ─────────────────────────────────────────
    paymentResult: {
      waitingTitle: 'お支払い待機中',
      waitingSubtitle: 'OnePay のページでお支払いを完了してください。\nこの画面は自動的に更新されます。',
      successTitle: 'お支払い完了',
      successSubtitle: '会員プランが有効になりました。',
      cardSaved: '次回請求のためにカードを保存しました',
      failedTitle: 'お支払い失敗',
      failedSubtitle: 'お支払いが完了しませんでした。もう一度お試しください。',
      timeoutTitle: 'お支払いタイムアウト',
      timeoutSubtitle: 'OnePay からの確認を受信できませんでした。お支払いを完了された場合、処理中の可能性があります。',
      plan: 'プラン',
      amount: '金額',
      status: 'ステータス',
      statusPending: '処理待ち',
      statusCompleted: '完了',
      statusFailed: '失敗',
      statusTimeout: 'タイムアウト',
      tryAgain: '再試行',
      backToHome: 'ホームに戻る',
      cancelGoBack: 'キャンセルして戻る',
    },

    // ─── Plan card metadata ────────────────────────────────────────────
    planMeta: {
      founding_member: { index: '01', badge: '先着50名限定' },
      standard_adult: { index: '02', note: '5月15日以降の料金' },
      founding_kids: { index: '03', badge: '先着50名限定' },
      standard_kids: { index: '04', note: '5/15以降 · 5〜15歳' },
      midday_specialist: { index: '05', note: 'パートタイムアクセス' },
    },

    // ─── Pickup Persons ───────────────────────────────────────────────
    pickup: {
      title: '迎え&緊急連絡先',
      sectionLabel: '迎え&緊急',
      subtitle: 'お子様を迎えに来られる方と、緊急時に連絡する方を登録します。',
      manage: '迎え許可者 ({{count}}人)',
      empty: 'まだ迎えの担当者がいません。お子様を迎えに来られる方を追加してください。',
      add: '迎え担当者を追加',
      addPerson: '迎え担当者を追加',
      editPerson: '迎え担当者を編集',
      name: '氏名',
      phone: '電話番号',
      relationship: '関係（例：おば）',
      relationshipPlaceholder: '例：おば、おじ、祖父母',
      emergencyName: '緊急連絡先氏名',
      emergencyPhone: '緊急連絡先電話番号',
      emergency: '緊急',
      addPhoto: '写真を追加',
      delete: '削除',
      deleteConfirm: 'この迎え担当者を削除しますか？',
      deleteConfirmMessage: 'この操作は元に戻せません。本当に削除しますか？',
      photoUploadError: '写真のアップロードに失敗しました',
      requiredFields: '氏名と電話番号は必須です',
      nameRequired: '氏名は必須です',
      phoneRequired: '電話番号は必須です',
      fieldRequired: 'この項目は必須です',
      photoRequired: '写真は必須です',
      accessDenied: 'アクセス拒否',
      promptTitle: '誰がお子様を迎えに来られますか？',
      promptBody: 'スタッフが誰をお子様を迎えに来られるかを知るため、迎え許可者と緊急連絡先を設定してください。',
      promptCta: '今すぐ設定',
      promptLater: '後で',
    },

    // ─── Backend error keys (returned as detail in HTTP errors) ───────
    errors: {
      not_authenticated: '認証されていません',
      invalid_token_payload: 'トークンの内容が無効です',
      invalid_or_expired_token: 'トークンが無効または期限切れです',
      user_not_found_or_inactive: 'ユーザーが見つからないか、無効化されています',
      insufficient_permissions: '権限が不足しています',
      role_not_authorized: 'このロールは許可されていません',
      not_authorized_athlete: 'この選手にアクセスする権限がありません',
      class_not_found: 'クラスが見つかりません',
      location_not_found: '場所が見つかりません',
      assignment_not_found: '割り当てが見つかりません',
      assignment_already_exists: '割り当てはすでに存在します',
      family_link_already_exists: 'ファミリーリンクはすでに存在します',
      not_authorized: '権限がありません',
      link_not_found: 'リンクが見つかりません',
      user_not_found: 'ユーザーが見つかりません',
      email_already_registered: 'このメールアドレスはすでに登録されています',
      invalid_credentials: 'メールアドレスまたはパスワードが正しくありません',
      invalid_qr_payload: 'QRコードの内容が無効です',
      qr_code_already_used: 'このQRコードはすでに使用されています',
      card_token_not_found: 'カードトークンが見つかりません',
      card_token_not_found_or_inactive: 'カードトークンが見つからないか、無効化されています',
      membership_not_found: '会員プランが見つかりません',
      missing_transaction_ref: '取引参照番号がありません',
      invalid_secure_hash: 'セキュアハッシュが無効です — 改ざんの可能性があります',
      payment_record_not_found: '支払い記録が見つかりません',
      internal_server_error: 'サーバー内部エラー',
      auto_logged_qr: 'QRチェックインにより自動記録されました',
      email_already_in_use: 'このメールアドレスは別のアカウントで使用されています',
      sub_user_already_active: 'この家族メンバーはすでにアカウントを有効化しています',
      no_bank_account_configured: 'VietQR決済用の銀行口座が設定されていません',
      not_a_vietqr_payment: 'これはVietQR決済ではありません',
      payment_already_completed: 'お支払いはすでに完了しています',
      payment_not_pending: 'お支払いは処理待ち状態ではありません',
      payment_expired: 'お支払いの有効期限が切れました',
      admin_only: 'この操作は管理者のみが実行できます',
      kids_plan_age_restriction: 'キッズプランは5〜15歳のみご利用いただけます',
      adult_plan_age_restriction: '大人向けプランは5〜15歳の方はご利用いただけません',
      cannot_delete_plan_with_subscribers: '会員がいるプランは削除できません。無効化してください。',
      cannot_delete_plan_with_members: '会員がいるプランは削除できません。無効化してください。',
      cannot_subscribe_to_archived_plan: '無効なプランには加入できません。',
      cannot_subscribe_to_inactive_plan: '無効なプランには加入できません。',
      membership_plan_not_found: '会員プランが見つかりません',
      cannot_delete_last_active_bank_account: '最後のアクティブな銀行口座は削除できません。先に別の口座を作成してください。',
      membership_time_restricted: 'チェックイン不可：会員プランは特定の時間帯のみ有効です',
      membership_day_restricted: 'チェックイン不可：本日は会員プランの対象外です',
      pickup_person_not_found: '迎え担当者が見つかりません',
      field_required: 'この項目は必須です',
      referral: {
        code_not_found: '紹介コードが見つかりません',
        already_used: 'この紹介コードはすでに使用されています',
        self_redeem: '自分の紹介コードは使用できません',
        same_family: '同じ家族のメンバーの紹介コードは使用できません',
        not_eligible_existing_member: '紹介コードは新規メンバーのみ使用できます',
        generation_failed: '紹介コードの生成に失敗しました。もう一度お試しください。',
        unknown: '紹介コードでエラーが発生しました',
      },
      legal_name_mismatch: '入力された名前がアカウント名と一致しません。',
      legal_scroll_required: '書類の最後までスクロールする必要があります。',
      legal_affirmations_required: '必須の確認事項をすべて受け入れる必要があります。',
      legal_sub_user_cannot_sign: '管理アカウントは法的書類に直接署名できません。',
      legal_doc_not_found: '書類が見つかりません。',
      guardian_waiver_required: 'アカウントアクセスには保護者免責事項が必要です。',
    },

    // ─── Belt names ────────────────────────────────────────────────────
    belts: {
      white: '白',
      grey: 'グレー',
      yellow: '黄',
      orange: 'オレンジ',
      green: '緑',
      blue: '青',
      purple: '紫',
      brown: '茶',
      black: '黒',
    },

    // ─── Skill Requirements (i18n-only, no DB) ────────────────────────
    skillRequirements: {
      white: {
        shrimp_hip_escape: {
          name: 'シュリンプ/ヒップエスケープ',
          description: '基本的なヒップムーブメントとエスケープテクニック',
        },
        bridge_roll_escape: {
          name: 'ブリッジ＆ロールエスケープ',
          description: 'マウントポジションからのエスケープ',
        },
        closed_guard_maintenance: {
          name: 'クローズドガード維持',
          description: 'クローズドガードポジションの維持',
        },
        armbar_from_guard: {
          name: 'ガードからのアームバー',
          description: 'クローズドガードからの基本的なサブミッション',
        },
        rear_naked_choke: {
          name: 'リアネイキッドチョーク',
          description: 'バックコントロールからの基本的なチョーク',
        },
      },
      grey: {
        guard_passing_basics: {
          name: 'ガードパッシング基礎',
          description: '基本的なガードパッシングテクニック',
        },
        triangle_choke_setup: {
          name: 'トライアングルチョークセットアップ',
          description: 'ガードからのトライアングルチョーク',
        },
        kimura_from_guard: {
          name: 'ガードからのキムラ',
          description: 'クローズドガードからのキムラロック',
        },
        side_control_escapes: {
          name: 'サイドコントロールエスケープ',
          description: 'サイドコントロールからのエスケープ',
        },
        basic_takedowns: {
          name: '基本的なテイクダウン',
          description: 'シングルレッグとダブルレッグテイクダウン',
        },
      },
      yellow: {},
      orange: {},
      green: {},
      blue: {},
      purple: {},
      brown: {},
      black: {},
    },

    // ─── Membership Management Screen ────────────────────────────────────
    mgmt: {
      title: 'メンバーシップ管理',
      membershipsTab: 'メンバーシップ',
      addMemberTab: 'メンバー追加',
      paymentsTab: '支払い',
      started: '開始日: {{date}}',
      startDate: '開始日',
      ended: '終了日: {{date}}',
      ends: '終了日: {{date}}',
      renew: '更新',
      renewEarly: '早期更新',
      addToPayment: '支払いに追加',
      queuedForPayment: '支払いに追加済み',
      renewalsSection: '更新',
      totalEstimateHint: '最終金額はお支払い画面で確認されます',
      renewalsDropped: '一部の更新は無効になったため削除されました。内容を確認してもう一度お試しください。',
      payNow: '今すぐ支払う',
      addPlan: 'プラン追加',
      selectPlan: 'プランを選択',
      selectNewPlan: '新しいプランを選択',
      addMember: 'メンバーを追加',
      addMemberStep1: 'メンバー情報を入力',
      addMemberPromptTitle: '家族メンバーを追加',
      addMemberPromptDesc: 'お子様や扶養家族を追加し、プランを選択します。',
      addAndPay: '追加して支払う',
      noMemberships: 'メンバーシップがありません',
      noMembershipsDesc: '家族メンバーを追加するか、プランを選択して始めましょう。',

      // プラン変更 / キャンセル
      changePlan: 'プラン変更',
      cancelMembership: 'メンバーシップをキャンセル',
      confirmCancelMembership: 'キャンセルする',
      cancelMembershipTitle: 'メンバーシップをキャンセルしますか？',
      cancelMembershipMessage: '現在のプランは期間終了まで有効です。追加の請求はなく、期間終了時にアクセスが終了します。',
      changeScheduledTitle: '変更が予約されました',
      changeScheduledMessage: '現在のプランは期間終了まで有効です。新しいプランはその後適用されます。',
      changeProratedHint: 'アップグレードは現在の期間の残り分について日割り計算されます。',
      payProrated: '日割り金額を支払う',
      scheduleChange: '変更を予約',

      // 予約済みバナー
      scheduledChangeTitle: '期間終了時に{{plan}}に切り替え',
      scheduledCancelTitle: 'キャンセルが予約されました',
      scheduledEndOfTerm: '現在のプランは期間終了まで有効です。',
      undo: '取り消し',
      // Additional keys
      upgrade: 'アップグレード',
      downgrade: 'ダウングレード（予約）',
      pendingChange: '予約済み変更',
      newMember: '新規メンバー',
      addToQueue: 'サマリーに追加',
      pendingChangesTitle: '変更を確認',
      pendingChangesSubtitle: '日割りアップグレード料金を支払うことを確認してください。ダウングレードは期間終了時に予約され、料金は発生しません。',
      planTransition: '{{from}} → {{to}}',
      proratedAmount: '日割り: {{amount}}',
      totalProrated: '日割り合計',
      noUpgradesScheduled: '料金なし — すべての変更は期間終了時に予約されています。',
      reviewAndPay: '確認して支払う',
      confirmChanges: '変更を確認',
      remove: '削除',
      scheduledAppliedTitle: '変更が予約されました',
      scheduledAppliedMessage: '期間終了時の変更が予約されました。料金は発生しません。',
    },

    // ─── Membership status ─────────────────────────────────────────────
    membershipStatus: {
      active: '有効',
      expired: '期限切れ',
      cancelled: 'キャンセル済み',
      paused: '一時停止中',
    },

    // ─── Payment status ────────────────────────────────────────────────
    paymentStatus: {
      pending: '処理待ち',
      completed: '完了',
      failed: '失敗',
      refunded: '返金済み',
    },

    // ─── Billing cycle ─────────────────────────────────────────────────
    billingCycle: {
      monthly: '月払い',
      quarterly: '四半期払い',
      annual: '年払い',
    },

    // ─── Legal ─────────────────────────────────────────────────────────
    legal: {
      gateTitle: '法的合意書',
      disclaimer: 'アプリの使用およびクラスのチェックイン/参加には、必要な書類を確認して署名してください。',
      progressLabel: '残り{{count}}件の書類',
      scrollHint: '下部まで読み進めて続行',
      scrollToEndToEnable: 'チェックボックスを有効にするために、書類の最後までお読みください。',
      signingFormTitle: '署名フォーム',
      signedTitle: '署名済み ✓',
      loadingNextDoc: '次の書類を読み込んでいます…',
      expandForm: 'フォームを展開',
      collapseForm: 'フォームを折りたたむ',
      signerNameLabel: 'フルの法的名前を入力',
      agreeAndSign: '同意して署名',
      signFailed: '合意書の送信に失敗しました',
      signedSuccess: '合意書の署名が完了しました',
      subUserBlockedTitle: 'アカウントアクセス保留中',
      subUserBlockedBody: '保護者が保護者免責事項に同意するまで、アプリを使用できません。保護者にサインインして必要な書類を完了するよう依頼してください。',
      adultSubUserInviteTitle: '成人被後見人のアカウント設定',
      adultSubUserInviteBody: '{{name}}さんは18歳以上であるため、自身の署名による免責事項および合意書への署名が必要です。後見人として大人の代わりに法的書類に署名することはできません。{{name}}さんをアプリに招待して個別のアカウントを作成し、自身で署名を完了するようにしてください。',
      adultSubUserStatusInvited: 'ステータス: {{email}}宛に招待送信済み',
      adultSubUserStatusPending: 'ステータス: 設定待ち',
      adultSubUserInstructionsInvited: '登録および免責事項の同意待ちです。相手の方は以下のQRコードをスキャンするか、招待リンクから登録と署名を行うことができます。',
      adultSubUserInstructionsPending: '以下の招待リンクまたはQRコードを共有し、自身でアカウントを登録して免責事項に署名できるようにしてください。',
      profileSection: '法的書類',
      viewPdf: 'PDFを表示',
      downloadCertificate: '証明書をダウンロード',
      reAgree: '再署名',
      agreed: '同意済み',
      updateRequired: '更新が必要',
      docs: {
        athlete_waiver: { title: '選手免責事項' },
        athlete_code_of_conduct: { title: '選手行動規範' },
        guardian_waiver: { title: '保護者免責事項' },
        guardian_code_of_conduct: { title: '保護者行動規範' },
      },
      affirmations: {
        athlete: {
          read_and_understand: '本書類を読み理解しました',
          legally_bound: '本書類に法的に拘束されることに同意します',
          voluntary_assumption_of_risk: 'リスクの自発的引受けを認めます',
          abide_by_rules: '規則と行動基準を遵守することに同意します',
        },
        guardian: {
          confirm_guardianship: '私は以下に記載された未成年者の親または法定後見人であることを確認します',
          read_and_understand: '本書類を読み、理解し、法的に拘束されることに同意します',
          voluntary_assumption_of_risk: '私は子供のためにリスクの自発的引受けと責任の放棄を認めます',
          data_consent: '私はCBJJ Saigonが[[PP_LINK]]に記載されている通り、会員および帯認定の目的で私の子供の個人データ（名前、生年月日、トレーニングの進捗を含む）を収集および処理することに同意します。',
          data_consent_over_7: '私と私の子供は[[PP_LINK]]に記載されている通り、個人データとトレーニングの進捗の収集に同意します。',
          abide_by_rules: '私は子供のために規則と行動基準を遵守することに同意します',
        },
      },
    },
    minorNameLabel: '未成年者の氏名（フルネーム）',
    guardianNameLabel: '保護者の氏名（フルネーム）',
    minorNameRequired: '未成年者の氏名を入力してください',
    allSignedTitle: '完了しました！ 🎉',
    allSignedMessage: '必要な書類はすべて署名済みです。会員資格が有効化され、アプリの利用とクラスのチェックインが可能です。',
    allSignedButton: 'アプリへ進む',

  },

  // ─── Account Deletion ─────────────────────────────────────────────
  accountDeletion: {
    title: 'アカウント削除',
    link: 'アカウントを削除',
    loggedOutIntro: 'CBJJ Saigonのアカウントおよび関連する個人データを削除する権利があります。続行するには、まずサインインして本人確認を行う必要があります。',
    loggedInIntro: 'この画面からCBJJ Saigonのアカウントおよび関連するすべての個人データを完全に削除できます。この操作は即時に行われ、取り消すことはできません。',
    planLossWarning: '警告：アカウントを削除すると、メンバーシッププランは即座に終了します。現在のプランに残り時間がある場合、返金は行われません。',
    stepsTitle: 'アカウント削除の方法',
    loggedOutStep1: '下のボタンを使用してCBJJ Saigonアカウントにサインインします。',
    loggedOutStep2: 'サインイン後、この画面に戻り、確認手順に従ってアカウントを削除します。',
    loggedOutStep3: '確認後、アカウントと個人データは即座に完全に削除されます。',
    loggedInStep1: '以上のデータ削除および保持情報を確認してください。',
    loggedInStep2: '「アカウント削除」をタップし、メールアドレスを入力して確認します。アカウントは即座に削除されます。',
    dataTitle: 'データの削除と保持',
    dataDeleted: '以下のデータは完全に削除されます：プロフィール情報（氏名、メールアドレス、生年月日、体重、身長）、トレーニングの進捗と帯の記録、クラスのチェックイン履歴、および家族/保護者のリンク。',
    subUsersDeleted: 'アカウントにリンクされている従属サブユーザー（独自のログインを持たない子供や家族メンバー）も、そのデータとともに削除されます。',
    subUsersRetained: '独自のメールログインを持つ登録済みの大人のサブユーザーは削除されません — アカウントとのリンクが解除されるだけで、独自のデータは保持されます。',
    dataRetained: '以下のデータは法令上の要件または正当な事業目的のため保持されます：支払い記録（請求先情報を含む）、署名済みの法的合意書、匿名化された集計統計、ベトナム税法で要求される財務取引記録、および適用される時効期間中保持される法的合意書のコピー。',
    retentionPeriod: '保持される財務記録および法的記録は、取引または合意の日付から最大7年間保持され、その後完全に削除されます。',
    signInButton: 'サインイン',
    requestButton: 'アカウント削除',
    confirmWarning: 'この操作によりアカウントは即座に完全に削除されます。プランへのアクセスは返金なしで失われます。確認のため、アカウントのメールアドレスを以下に入力してください。',
    yourEmail: 'アカウントのメールアドレス',
    emailConfirmLabel: '確認のためメールアドレスを入力',
    emailMismatch: '入力されたメールアドレスがアカウントのメールアドレスと一致しません。',
    confirmButton: 'アカウントを削除',
    requestFailed: 'アカウントの削除に失敗しました。後でもう一度お試しください。',
    successTitle: 'アカウント削除済み',
    successBody: 'アカウントが完全に削除されました。サインアウトされました。',
    cancel: 'キャンセル',
    goToLogin: 'ログインへ',
  },
};

export default ja;
